import { styled } from '@mui/material/styles';
import Markets from '@/constants/Markets';
import { useQuery } from '@tanstack/react-query';
import { fetchFilters } from '@/lib/api';

const MarketHeader = ({ marketId }: { marketId: string | null }) => {
  const { data } = useQuery({
    queryKey: ['filters'],
    queryFn: fetchFilters,
  });

  const marketData = data?.markets?.find(
    (m) => m.market_id === Number(marketId),
  );
  const market = marketData?.market_name
    ? Markets[marketData.market_name]
    : null;

  if (!market) {
    return null;
  }

  return (
    <Root>
      {market.icon && <MarketIcon>{market.icon}</MarketIcon>}
      <MarketName>{market.label}</MarketName>
    </Root>
  );
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: `${theme.spacing(2)} 40px`,
  gap: theme.spacing(2),
}));

const MarketIcon = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 60,
  height: 60,

  svg: {
    width: '100%',
    height: '100%',
  },
}));

const MarketName = styled('div')(({ theme }) => ({
  fontSize: 24,
  lineHeight: '28px',
  fontWeight: 600,
  color: theme.palette.textPrimaryBlack,
}));

export default MarketHeader;
